import { Bounds } from "../geometry.bounds";
import { Cartesian2, Cartesian3 } from "../geometry.cartesian";
import { RegionCode } from "../geometry.interfaces";
import { AbstractShape } from "./geometry.shape";
import { ShapeType } from "./geometry.shapes.interfaces";
export class Line extends AbstractShape {
    constructor(a, b) {
        super(ShapeType.Line);
        this._alice = a;
        this._bob = b;
    }
    get start() {
        return this._alice;
    }
    set start(v) {
        if (Cartesian3.Equals(v, this._alice) == false) {
            this._alice = v;
            this.invalidateBounds();
        }
    }
    get end() {
        return this._bob;
    }
    set end(v) {
        if (Cartesian3.Equals(v, this._bob) == false) {
            this._bob = v;
            this.invalidateBounds();
        }
    }
    clip(clipArea) {
        let code1 = Cartesian2.ComputeCode(this._alice, clipArea);
        let code2 = Cartesian2.ComputeCode(this._bob, clipArea);
        if (code1 == 0 && code2 == 0) {
            return this;
        }
        if (code1 & code2) {
            return undefined;
        }
        let a = new Cartesian3(this._alice.x, this._alice.y, this._alice.z);
        let b = new Cartesian3(this._bob.x, this._bob.y, this._bob.z);
        do {
            let code_out = code1 != 0 ? code1 : code2;
            let x = 0, y = 0;
            const x1 = a.x;
            const y1 = a.y;
            const x2 = b.x;
            const y2 = b.y;
            if (code_out & RegionCode.TOP) {
                const y_max = clipArea.ymax;
                x = x1 + ((x2 - x1) * (y_max - y1)) / (y2 - y1);
                y = y_max;
            }
            else if (code_out & RegionCode.BOTTOM) {
                const y_min = clipArea.ymin;
                x = x1 + ((x2 - x1) * (y_min - y1)) / (y2 - y1);
                y = y_min;
            }
            else if (code_out & RegionCode.RIGHT) {
                const x_max = clipArea.xmax;
                y = y1 + ((y2 - y1) * (x_max - x1)) / (x2 - x1);
                x = x_max;
            }
            else if (code_out & RegionCode.LEFT) {
                const x_min = clipArea.xmin;
                y = y1 + ((y2 - y1) * (x_min - x1)) / (x2 - x1);
                x = x_min;
            }
            if (code_out == code1) {
                a.x = x;
                a.y = y;
                code1 = Cartesian2.ComputeCode(a, clipArea);
            }
            else {
                b.x = x;
                b.y = y;
                code2 = Cartesian2.ComputeCode(b, clipArea);
            }
        } while (code1 != 0 || code2 != 0);
        return new Line(a, b);
    }
    _buildBounds() {
        return Bounds.FromPoints2(this._alice, this._bob);
    }
    _getPoints() {
        return [this._alice, this._bob];
    }
}
//# sourceMappingURL=geometry.line.js.map